module.exports = __webpack_public_path__ + "static/media/minuscircle.3cc8e273.svg";